var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C12.2034 0 10.4803 0.719247 9.20992 1.99951C7.93951 3.27978 7.22581 5.0162 7.22581 6.82677C7.22581 8.63734 7.93951 10.3738 9.20992 11.654C10.4803 12.9343 12.2034 13.6535 14 13.6535C15.7966 13.6535 17.5197 12.9343 18.7901 11.654C20.0605 10.3738 20.7742 8.63734 20.7742 6.82677C20.7742 5.0162 20.0605 3.27978 18.7901 1.99951C17.5197 0.719247 15.7966 0 14 0ZM6.77419 17.2945C4.97757 17.2945 3.25452 18.0137 1.98412 19.294C0.713708 20.5743 0 22.3107 0 24.1212V26.284C0 27.6566 0.986322 28.8253 2.33032 29.0456C10.0583 30.3181 17.9417 30.3181 25.6697 29.0456C26.3201 28.9389 26.9117 28.6025 27.3386 28.0965C27.7656 27.5906 28 26.9481 28 26.284V24.1212C28 22.3107 27.2863 20.5743 26.0159 19.294C24.7455 18.0137 23.0224 17.2945 21.2258 17.2945H20.6116C20.2774 17.2945 19.945 17.3491 19.6289 17.451L18.0645 17.9662C15.4234 18.835 12.5766 18.835 9.93548 17.9662L8.3711 17.451C8.05434 17.3472 7.7233 17.2943 7.39019 17.2945H6.77419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.620320d4128a6400d62f7c91eecb84fc.svg";
export { ForwardRef as ReactComponent };